import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import supabase from "../lib/supabaseClient";
import CvDocument from "./CvDocument";
import { orderAscending } from "../admin/collectionsConfig";

// Fetches all CV data from Supabase. Throws "no-profile" when the profile
// row hasn't been seeded yet, or the underlying query error.
export async function fetchCvData() {
  const tables = ["profile", "experience", "studies", "skills", "languages", "certifications", "categories"];
  const results = await Promise.all(
    tables.map((t) =>
      t === "profile"
        ? supabase.from(t).select("*").limit(1).maybeSingle()
        : supabase.from(t).select("*").order("order", { ascending: orderAscending(t) })
    )
  );
  // Categories may not exist on older databases — don't fail the whole PDF for it.
  const failed = results
    .slice(0, 6)
    .find((r) => r && r.error);
  if (failed) throw new Error(failed.error.message || "fetch-failed");

  const data = {
    profile: results[0].data,
    experience: results[1].data || [],
    studies: results[2].data || [],
    skills: results[3].data || [],
    languages: results[4].data || [],
    certifications: results[5].data || [],
    categories: results[6].data || [],
  };
  if (!data.profile) throw new Error("no-profile");
  return data;
}

// Builds the PDF blob and triggers a download. Accepts pre-fetched data
// (from the preview) or fetches it when omitted.
export async function downloadCvPdf(data, language) {
  const cvData = data || (await fetchCvData());
  const blob = await pdf(<CvDocument data={cvData} language={language} />).toBlob();
  saveAs(blob, `CV-${(cvData.profile?.name || "cv").replace(/\s+/g, "")}-${language}.pdf`);
}

export function useDownloadCv(language) {
  async function download() {
    await downloadCvPdf(null, language);
  }
  return { download };
}
